var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import styled from 'styled-components';
import Divider from 'antd/lib/divider';
import { COLORS } from 'renderer/styles';
import React from 'react';
export var StyledDivider = styled(function (_a) {
    var marginTop = _a.marginTop, marginBottom = _a.marginBottom, marginLeft = _a.marginLeft, marginRight = _a.marginRight, rest = __rest(_a, ["marginTop", "marginBottom", "marginLeft", "marginRight"]);
    return (React.createElement(Divider, __assign({}, rest)));
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-top: ", "px;\n  margin-bottom: ", "px;\n  margin-left: ", "px;\n  margin-right: ", "px;\n  border-top: 1px solid ", ";\n"], ["\n  margin-top: ", "px;\n  margin-bottom: ", "px;\n  margin-left: ", "px;\n  margin-right: ", "px;\n  border-top: 1px solid ", ";\n"])), function (props) { return props.marginTop || 0; }, function (props) { return props.marginBottom || 0; }, function (props) { return props.marginLeft || 0; }, function (props) { return props.marginRight || 0; }, COLORS.gray6);
var templateObject_1;
